"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const antd_mask_input_1 = __importDefault(require("antd-mask-input"));
const react_1 = __importStar(require("react"));
const family_svg_1 = __importDefault(require("../../../../assets/images/family.svg"));
const data_repository_1 = require("../../../../dataSource/data_repository");
const detectDevice_1 = __importDefault(require("../../../../utils/detectDevice"));
const notification_1 = require("../../../../utils/notification");
require("./ContactStyles.scss");
const constants_1 = require("../../../../assets/constants/constants");
const Contact = () => {
    const { isMobile } = (0, detectDevice_1.default)(900);
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [name, setName] = (0, react_1.useState)('');
    const sendInformationsPriority = () => {
        const params = {
            name,
            telephone: phoneNumber.replace(/\D/g, ''),
        };
        (0, data_repository_1.createOwnerWithPriority)(params)
            .then(response => {
            if (!response.isError) {
                (0, notification_1.NotificationSucessElementInformations)();
            }
            else {
                (0, notification_1.NotificationWarningElement)();
            }
        })
            .catch(err => {
            (0, notification_1.NotificationErrorElement)();
        });
    };
    const ContentFactory = () => {
        if (isMobile) {
            return (react_1.default.createElement("div", { className: "form" },
                react_1.default.createElement("div", { className: "more-info-form" },
                    react_1.default.createElement("span", null, "Solicite mais informa\u00E7\u00F5es"),
                    react_1.default.createElement(antd_mask_input_1.default, { value: phoneNumber, type: "tel", id: "masked-input", mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX", className: "masked-input", onChange: e => setPhoneNumber(e.target.value) }),
                    react_1.default.createElement(antd_1.Input, { placeholder: "nome*", className: "masked-input", onChange: e => setName(e.target.value) }),
                    react_1.default.createElement(antd_1.Button, { onClick: sendInformationsPriority, className: "send-contact" }, "Enviar")),
                react_1.default.createElement("div", { className: "phone-contact" },
                    react_1.default.createElement("span", null, "Entre j\u00E1 em contato"),
                    react_1.default.createElement("span", null, constants_1.OWNER_INFORMATIONS.email),
                    react_1.default.createElement("span", null, constants_1.OWNER_INFORMATIONS.telephone),
                    react_1.default.createElement("span", null, constants_1.OWNER_INFORMATIONS.cell)),
                react_1.default.createElement("div", { className: "social-media" },
                    react_1.default.createElement("span", null, "Nossas redes"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.linkedin.com/company/360suites" }, "Linkedin"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.facebook.com/360suites/" }, "Facebook"),
                    react_1.default.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://www.instagram.com/360suites/" }, "Instagram"))));
        }
        return (react_1.default.createElement("div", { className: "form" },
            react_1.default.createElement("div", { className: "phone-contact" },
                react_1.default.createElement("span", null, "Entre j\u00E1 em contato"),
                react_1.default.createElement("span", null, constants_1.OWNER_INFORMATIONS.email),
                react_1.default.createElement("span", null,
                    react_1.default.createElement(icons_1.PhoneFilled, null),
                    ` ${constants_1.OWNER_INFORMATIONS.telephone}`),
                react_1.default.createElement("span", null,
                    react_1.default.createElement(icons_1.WhatsAppOutlined, null),
                    ` ${constants_1.OWNER_INFORMATIONS.cell}`)),
            react_1.default.createElement("div", { className: "more-info-form" },
                react_1.default.createElement("span", null, "Solicite mais informa\u00E7\u00F5es"),
                react_1.default.createElement(antd_1.Input, { placeholder: "nome*", className: "masked-input", onChange: e => setName(e.target.value) }),
                react_1.default.createElement(antd_mask_input_1.default, { id: "masked-input", mask: "(11) 11111-1111", placeholder: "(XX) XXXXX-XXXX", className: "masked-input", onChange: e => setPhoneNumber(e.target.value) }),
                react_1.default.createElement(antd_1.Button, { onClick: sendInformationsPriority, className: "send-contact" }, "Enviar")),
            react_1.default.createElement("div", { className: "social-media" },
                react_1.default.createElement("span", null, "Nossas redes"),
                react_1.default.createElement("a", { target: "_blank", href: "https://www.linkedin.com/company/360suites", rel: "noreferrer" }, "Linkedin"),
                react_1.default.createElement("a", { target: "_blank", href: "https://www.facebook.com/360suites/", rel: "noreferrer" }, "Facebook"),
                react_1.default.createElement("a", { target: "_blank", href: "https://www.instagram.com/360suites/", rel: "noreferrer" }, "Instagram"))));
    };
    return (react_1.default.createElement("div", { className: "Contact" },
        react_1.default.createElement("img", { className: "bg-image", src: family_svg_1.default, alt: "form-bg", loading: "lazy" }),
        ContentFactory()));
};
exports.default = Contact;
